/**
 * HomePage Surface Component
 * Main workspace surface for FreshCards
 */

import React from 'react';
import { Stack, Title, Text, SimpleGrid, Paper, Group, Badge, ThemeIcon, rem } from '@mantine/core';
import { IconFolder, IconDatabase, IconSparkles, IconNote } from '@tabler/icons-react';

interface HomePageProps {
  phase?: number;
  currentPageId?: string;
}

const HomePage: React.FC<HomePageProps> = ({ phase = 1 }) => {
  return (
    <Stack gap="lg" p="md">
      <Group justify="space-between" align="center">
        <div>
          <Title order={2}>Welcome to FreshCards</Title>
          <Text c="dimmed" size="sm">Your modular productivity workspace</Text>
        </div>
        <Badge size="lg" variant="light" color="blue">Phase {phase}</Badge>
      </Group>

      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
        <Paper p="md" radius="md" withBorder>
          <Group>
            <ThemeIcon size="xl" radius="md" variant="light" color="blue">
              <IconFolder size={rem(24)} />
            </ThemeIcon>
            <div>
              <Text fw={600}>Docs</Text>
              <Text size="xs" c="dimmed">1 item</Text>
            </div>
          </Group>
        </Paper>

        <Paper p="md" radius="md" withBorder>
          <Group>
            <ThemeIcon size="xl" radius="md" variant="light" color="green">
              <IconDatabase size={rem(24)} />
            </ThemeIcon>
            <div>
              <Text fw={600}>DBs</Text>
              <Text size="xs" c="dimmed">3 items</Text>
            </div>
          </Group>
        </Paper>

        <Paper p="md" radius="md" withBorder>
          <Group>
            <ThemeIcon size="xl" radius="md" variant="light" color="grape">
              <IconSparkles size={rem(24)} />
            </ThemeIcon>
            <div>
              <Text fw={600}>AI</Text>
              <Text size="xs" c="dimmed">7 items</Text>
            </div>
          </Group>
        </Paper>

        <Paper p="md" radius="md" withBorder>
          <Group>
            <ThemeIcon size="xl" radius="md" variant="light" color="orange">
              <IconNote size={rem(24)} />
            </ThemeIcon>
            <div>
              <Text fw={600}>Quick Note</Text>
              <Text size="xs" c="dimmed">1 item</Text>
            </div>
          </Group>
        </Paper>
      </SimpleGrid>

      <Paper p="lg" radius="md" withBorder>
        <Title order={4} mb="md">Getting Started</Title>
        <Stack gap="xs">
          <Text size="sm">• Use the sidebar to navigate between surfaces</Text>
          <Text size="sm">• Press Ctrl+K to open the command palette</Text>
          <Text size="sm">• Click on any card above to explore features</Text>
          <Text size="sm">• Phase badges indicate feature completion status</Text>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default HomePage;